import { decode } from 'he';
import { isStringLiteral } from '@enonic/js-utils/value/isStringLiteral';

export function safeHtmlDecode(value: unknown): string {
	if (isStringLiteral(value)) return decode(value);
	return ''; // An empty string is Falsy :)
}
